<script>
  import { api } from "../../../../../helpers";
  import { list } from "../../../../stores";
  import { viewAllVideosData } from "../../store";
  import {_} from 'svelte-i18n';

  let controller = new AbortController()
  let signal = controller.signal

  const viewPublication = async () => {
    const isAllView = $viewAllVideosData.i_view === 100;
    const urlMethod = isAllView ? 'delete' : 'create'
    const method = isAllView ? 'DELETE' : 'POST'
    const url = `/api/v1/view-publication/${urlMethod}/${$viewAllVideosData.id}/`

    controller.abort()
    controller = new AbortController()
    signal = controller.signal

    await api(url, method, {}, false, signal)

    $viewAllVideosData.i_view = isAllView ? 0 : 100  

    $viewAllVideosData.videos.forEach((video) => {
      video.is_view = true;
    });

    $list = $list;

    $viewAllVideosData = null;
  }
</script>

{#if $viewAllVideosData}
  <div class="view-videos-modal">
    <div class="modal-content">
      <div class="close-icon" on:click={() => $viewAllVideosData = null}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.92849 2.92893C-0.97474 6.83216 -0.97474 13.1678 2.92849 17.0711C6.83172 20.9743 13.1674 20.9743 17.0706 17.0711C20.9739 13.1678 20.9739 6.83216 17.0706 2.92893C13.1674 -0.974297 6.83172 -0.974297 2.92849 2.92893ZM13.5351 7.87868L11.4138 10L13.5351 12.1213C13.924 12.5102 13.924 13.1466 13.5351 13.5355C13.1462 13.9244 12.5098 13.9244 12.1209 13.5355L9.99956 11.4142L7.87824 13.5355C7.48933 13.9244 6.85293 13.9244 6.46402 13.5355C6.07511 13.1466 6.07511 12.5102 6.46402 12.1213L8.58534 10L6.46402 7.87868C6.07511 7.48977 6.07511 6.85338 6.46402 6.46447C6.85293 6.07556 7.48933 6.07556 7.87824 6.46447L9.99956 8.58579L12.1209 6.46447C12.5098 6.07556 13.1462 6.07556 13.5351 6.46447C13.924 6.85338 13.924 7.48977 13.5351 7.87868Z" fill="#C3CAD9"/>
        </svg>        
      </div>

      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="60" height="60" rx="30" fill="#EFF1FD"/>
        <path d="M29.4941 22.864C28.6408 22.864 28.0221 22.672 27.6381 22.288C27.2755 21.904 27.0941 21.4133 27.0941 20.816V20.176C27.0941 19.5787 27.2755 19.088 27.6381 18.704C28.0221 18.32 28.6408 18.128 29.4941 18.128C30.3261 18.128 30.9341 18.32 31.3181 18.704C31.7021 19.088 31.8941 19.5787 31.8941 20.176V20.816C31.8941 21.4133 31.7021 21.904 31.3181 22.288C30.9341 22.672 30.3261 22.864 29.4941 22.864ZM27.4461 25.296H31.5421V42H27.4461V25.296Z" fill="#2B50ED"/>
      </svg>      

      <div class="title">
        {@html $_('seenEverythingConfirmation')}
      </div>

      <div class="description">
        {$_('postContains')} {$viewAllVideosData.videos.length} {$_('Videos').toLocaleLowerCase()}
      </div>

      <div class="buttons">
        <button type="button" on:click={() => $viewAllVideosData = null}>{$_('cancel')}</button>
        <button type="button" on:click={viewPublication}>{$_('seenConfirm')}</button>
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  .view-videos-modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #00000066;
    z-index: 100000000000000000;

    .modal-content {
      box-shadow: 0px 2px 5px 0px #26334D08;
      color: #22252C;
      background-color: white;
      max-width: 604px;
      width: 100%;
      border-radius: 20px;
      position: absolute;
      left: 50%;
      transform: translate(-50%,-50%);
      text-align: center;
      padding: 24px;
      box-sizing: border-box;

      .close-icon {
        position: absolute;
        right: 0;
        top: 0;
        padding: 16px;
        cursor: pointer;

        @media (max-width: 576px) {
          padding: 12px;
        }
      }

      @media (min-width: 576px) {
        top: 50%;
      }

      @media (max-width: 576px) {
        bottom: 0;
        left: 0;
        transform: none;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;

        svg {
          height: 32px;
          width: 32px;
        }
      }

      .title {
        font-size: 20px;
        font-weight: 600;
        line-height: 29px;
        margin-top: 24px;

        @media (max-width: 576px) {
          font-size: 16px;
          line-height: 23px;
        }
      }
      
      .description {
        font-size: 16px;
        font-weight: 400;
        line-height: 23px;
        margin-top: 16px;
        
        @media (max-width: 576px) {
          margin-top: 8px;
          font-size: 14px;
          line-height: 20px;
        }
      }

      .buttons {
        margin-top: 24px;
        display: flex;
        grid-gap: 16px;
        justify-content: center;

        @media (max-width: 576px) {
          flex-direction: column;
          grid-gap: 8px;
        }

        button {
          width: 220px;
          border: none;
          border-radius: 30px;
          padding: 14px 0;
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          text-align: center;

          @media (max-width: 576px) {
            width: 100%;
          }

          &:first-child {
            background: #576CED1A;
            color: #2B50ED;
          }

          &:last-child {
            color: white;
            background: #2B50ED;
          }
        }
      }
    }
  }
</style>